import { Reducer } from "redux";
import { RequirementTypesAction, RequirementTypesActionTypes } from "./RequirementTypesActions";
import RequirementTypesState from "./RequirementTypesState";

const initialState: RequirementTypesState = {
  requiremntTypes: []
}

const RequirementTypesReducer: Reducer<RequirementTypesState, RequirementTypesAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case RequirementTypesActionTypes.SET_REQUIREMENT_TYPES: {
      return {
        ...state,
        requiremntTypes: [...action.data],
      };
    }
    default: {
      return state;
    }
  }
};

export default RequirementTypesReducer;